import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import * as React from 'react';

const Content = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly'
}));

interface AccordionContentProps {
  children: React.ReactNode;
}

const AccordionContent: React.FC<AccordionContentProps> = props => {
  return <Content variant='body2'>{props.children}</Content>;
};

export default AccordionContent;
